import axios from "@/store/axios";
import {V1API} from "@/http/APIPath";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";
import dataMagic, {decode, encode} from "@/store/dataMagic"
import ToastificationContent from "@core/components/toastification/ToastificationContent";

const keyList = {
    applicationUpdate : 'APPLICATION_UPDATE',
    applicationDelete : 'APPLICATION_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,
    state : {
        application: [],
        applicationLoading: false,
        applicationError: false,
        submitLoading: false,
        submitError: false,
        submitSuccess: false,


        ...store
    },
    mutations : {
        ...mutations,
        SET_APPLICATION (state, application) {
            state.application = application;
        },

        APPLICATION_LOADING (state, loading) {
            state.applicationLoading = loading;
        },
        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },
    actions: {
        async updateApplication({commit, state, dispatch}, payload) {
            let response = '';
            await performNetworkCall(
                commit,
                keyList.applicationUpdate,
                async () => {
                    let payloadData={
                        title: payload.title
                    }
                    let magic=encode(payloadData)
                    response = await axios.patch(V1API.application+"/"+payload.id,magic.encodedPayload,magic.config).then(result => {
                        let data=decode(result.data)
                        return data.message
                    })

                    dispatch('fetchApplication');

                }
            )
            return response
        },



        async deleteApplication({commit, state, dispatch}, payload) {
            let response='';
            await performNetworkCall(
                commit,
                keyList.applicationDelete,
                async () => {

                    response = await axios.delete(V1API.application+'/'+payload).then(result=>{
                        let data=decode(result.data)

                        return data.message

                    });
                    dispatch('fetchApplication');
                }
            )

            return response
        },

        async fetchApplication ({ commit },payload) {
            commit('APPLICATION_LOADING', true);
            commit('APPLICATION_ERROR', false);
            try{

                let result = await axios.get(V1API.application);
                let response=decode(result.data)
                console.log(response)
                commit('SET_APPLICATION', response.data);

            }catch(error) {

                commit('APPLICATION_ERROR', true);

            }
            commit('APPLICATION_LOADING', false);
        },
        async fetchApplicationByID ({ commit },payload) {
            commit('APPLICATION_LOADING', true);
            commit('APPLICATION_ERROR', false);
            try{

                let result = await axios.get(V1API.application+'/'+payload);
                let response=decode(result.data)
                console.log(response.data)
                commit('SET_APPLICATION', response.data);

            }catch(error) {

                commit('APPLICATION_ERROR', true);

            }
            commit('APPLICATION_LOADING', false);
        },
        async addApplication({commit,dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);
            try{
                let magic=encode(payload)
                let response = await axios.post(V1API.application,magic.encodedPayload,magic.config).then(result=>{
                    let data=decode(result.data)

                    return data.message

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchApplication')
                return response
            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

    },
    getters: {}
}
